import CancelRide from './CancelRide';

export default CancelRide;
